import { useState } from "react";
import { CommonType } from "../../../types";

export type DeviceFormErrors = Partial<Record<"deviceName" | "serialNumber" | "selectedDeviceType" | "selectedParserConfig", string>>;

export interface DeviceGroupOption { id: number; name: string; }

export const useDeviceFormState = () => {
  const [deviceName, setDeviceName] = useState("");
  const [serialNumber, setSerialNumber] = useState("");
  const [description, setDescription] = useState("");
  const [parserConfigs, setParserConfigs] = useState<CommonType[]>([]);
  const [selectedParserConfig, setSelectedParserConfig] = useState<CommonType | null>(null);
  const [deviceTypes, setDeviceTypes] = useState<CommonType[]>([]);
  const [selectedDeviceType, setSelectedDeviceType] = useState<CommonType | null>(null);
  const [iconId, setIconId] = useState(0);
  const [deviceGroups, setDeviceGroups] = useState<DeviceGroupOption[]>([]);
  const [selectedDeviceGroup, setSelectedDeviceGroup] = useState<DeviceGroupOption | null>(null);
  const [errors, setErrors] = useState<DeviceFormErrors>({});

  const clearError = (field: keyof DeviceFormErrors) =>
    setErrors((prev) => ({ ...prev, [field]: undefined }));

  const resetForm = () => {
    setDeviceName("");
    setSerialNumber("");
    setDescription("");
    setSelectedParserConfig(null);
    setSelectedDeviceType(null);
    setSelectedDeviceGroup(null);
    setIconId(0);
    setErrors({});
  };

  return {
    deviceName, setDeviceName,
    serialNumber, setSerialNumber,
    description, setDescription,
    parserConfigs, setParserConfigs,
    selectedParserConfig, setSelectedParserConfig,
    deviceTypes, setDeviceTypes,
    selectedDeviceType, setSelectedDeviceType,
    deviceGroups, setDeviceGroups,
    selectedDeviceGroup, setSelectedDeviceGroup,
    iconId, setIconId,
    errors, setErrors, clearError,
    resetForm,
  };
};
